import { Covenants } from "types/Covenants";
import { ActionType, getType } from "typesafe-actions";
import * as covenantsActions from "./covenantsActions";

export interface CovenantsState {
  loading?: boolean;
  data?: Covenants[];
  count?: number;
  loadingCount?: boolean;
  countError?: string;
  error?: string;
}

export type CovenantsActions = ActionType<typeof covenantsActions>;

export default function covenants(state: CovenantsState = {}, action: CovenantsActions) {
  switch (action.type) {
    case getType(covenantsActions.load):
      return { ...state, loading: true };
    case getType(covenantsActions.loadSuccess):
      const data = action.data?.map((d) => ({ ...d }));
      return { ...state, loading: false, data, error: undefined };
    case getType(covenantsActions.loadFail):
      return { ...state, loading: false, error: action.error };
    case getType(covenantsActions.loadCount):
      return { ...state, loadingCount: true };
    case getType(covenantsActions.loadCountSuccess):
      return { ...state, loading: false, loadingCount: true, count: action.data, error: undefined };
    case getType(covenantsActions.loadCountFail):
      return { ...state, loadingCount: false, countError: action.error };
    default:
      return state;
  }
}
